import { useEffect, useState } from 'react'
import useAuth from 'src/hooks/useAuth'
import SolicitacoesKanbanContext from './context'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  listagemColunaKanban,
  listagemKanban
} from 'src/api/solicitacao-orcamento'
import { IColunaKanban, ISolicitacaoKanban } from './types'

const SolicitacoesKanbanProvider = ({ children }) => {
  const { user, signed, perfilAtual } = useAuth()
  const queryClient = useQueryClient()

  const {
    data: colunas,
    isLoading
    // error, isError, refetch
  } = useQuery(
    ['colunas', user?.id],
    async () => {
      var response = await listagemKanban()
      var colunasCarregadas = response.data
      colunasCarregadas.forEach(coluna => {
        coluna.carregarMais = () => carregarMaisPorColuna(coluna)
      })
      return colunasCarregadas
    },
    {
      // refetchOnWindowFocus: true,
      // onSuccess: data => {}
      // cacheTime: 1 * (1000 * 60) //1 minuto
    }
  )

  const mutation = useMutation({
    mutationFn: async (coluna: IColunaKanban<ISolicitacaoKanban>) => {
      var response = await listagemColunaKanban(coluna.id, coluna.dados.length)
      return response.data
    },
    onSuccess: (data, coluna, context) => {
      queryClient.setQueriesData(
        'colunas',
        (colunasAtuais: IColunaKanban<ISolicitacaoKanban>[]) => {
          var colunaAtual = colunasAtuais.find(c => c.id === coluna.id)
          colunaAtual.dados = [...colunaAtual.dados, ...data]
          colunaAtual.loading = false

          return colunasAtuais
        }
      )
    }
  })

  const carregarMaisPorColuna = async (
    coluna: IColunaKanban<ISolicitacaoKanban>
  ) => {
    queryClient.setQueriesData(
      'colunas',
      (colunasAtuais: IColunaKanban<ISolicitacaoKanban>[]) => {
        var colunaAtual = colunasAtuais.find(c => c.id === coluna.id)
        colunaAtual.loading = true
        return colunasAtuais
      }
    )
    mutation.mutate(coluna)
  }

  useEffect(() => {}, [signed, perfilAtual])

  return (
    <SolicitacoesKanbanContext.Provider value={{ loading: isLoading, colunas }}>
      {children}
    </SolicitacoesKanbanContext.Provider>
  )
}

export default SolicitacoesKanbanProvider
